// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AddToList: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 12 12"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                d="M6 1.125a4.875 4.875 0 110 9.75 4.875 4.875 0 010-9.75zM6 12A6 6 0 106 0a6 6 0 000 12zm-.562-3.375h1.125V6.562h2.062V5.438H6.563V3.375H5.438v2.063H3.375v1.125h2.063v2.062z"
                opacity=".5"
            />
        </svg>
    );
};

export default React.memo(AddToList);
